import { Menu, MenuItem } from "@mui/material";
import { getValueTypeColor } from "../../../../util/src/blueprint/method.js";
import type { KeyframeAddablePortId } from "../../../../util/src/blueprint/anim-keyframe-ports.js";
import {
  KEYFRAME_EASING_PORT_ID,
  getKeyframeAddablePortLabel,
  type AnimKeyframePortLabels,
} from "../../../../util/src/blueprint/anim-keyframe-ports.js";
import dico from "../../../../util/src/language/dico.js";

export interface KeyframePortAddMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  availablePortIds: KeyframeAddablePortId[];
  labels: AnimKeyframePortLabels;
  onClose: () => void;
  onSelect: (portId: KeyframeAddablePortId) => void;
}

/**
 * Menu listing addable keyframe ports (easing + animatable properties).
 * Labels and types come from the keyframe port catalog - no free-form label step.
 */
export const KeyframePortAddMenu = ({
  anchorEl,
  open,
  availablePortIds,
  labels,
  onClose,
  onSelect,
}: KeyframePortAddMenuProps) => {
  const emptyLabel = dico().behavior.animation.addPortEmpty;

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      {availablePortIds.length === 0 ? (
        <MenuItem disabled sx={{ fontSize: 12 }}>
          {emptyLabel}
        </MenuItem>
      ) : (
        availablePortIds.map((portId) => {
          const valueType =
            portId === KEYFRAME_EASING_PORT_ID ? "animationEasing" : "number";
          return (
            <MenuItem
              key={portId}
              onClick={() => {
                onSelect(portId);
                onClose();
              }}
              sx={{ gap: 1, fontSize: 12 }}
            >
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: getValueTypeColor(valueType),
                  flexShrink: 0,
                }}
              />
              {getKeyframeAddablePortLabel(portId, labels)}
            </MenuItem>
          );
        })
      )}
    </Menu>
  );
};
